/* Bold V3 — Style 2 product card.
   Swatch click swaps the image, its alt text and the quick-add size run.
   Size click adds to cart through the theme's own CartDrawer.renderContents()
   pipeline, so the drawer refreshes and opens exactly as it does elsewhere. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ADD_URL = (window.routes && window.routes.cart_add_url) || (ROOT + 'cart/add');

  function data(card) {
    if (card.__bold) return card.__bold;
    var el = card.querySelector('[data-bold-card-data]');
    if (!el) return null;
    try { card.__bold = JSON.parse(el.textContent); } catch (e) { return null; }
    return card.__bold;
  }

  function colourFor(card, name) {
    var d = data(card);
    if (!d || !d.colours || !d.colours.length) return null;
    if (!name) return d.colours[0];
    for (var i = 0; i < d.colours.length; i++) {
      if (d.colours[i].name === name) return d.colours[i];
    }
    return d.colours[0];
  }

  function renderSizes(card, colour) {
    var wrap = card.querySelector('[data-bold-sizes]');
    if (!wrap || !colour) return;
    wrap.innerHTML = '';
    (colour.sizes || []).forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bold-card__qa-size';
      b.textContent = s.v;
      if (s.a && s.id) { b.setAttribute('data-variant-id', String(s.id)); }
      else { b.disabled = true; }
      wrap.appendChild(b);
    });
  }

  function selectColour(card, name) {
    var colour = colourFor(card, name);
    if (!colour) return;
    var img = card.querySelector('[data-bold-img]');
    if (img && colour.image) { img.src = colour.image; img.alt = colour.alt || img.alt; }
    card.querySelectorAll('[data-bold-swatch]').forEach(function (sw) {
      sw.setAttribute('aria-pressed', String(sw.getAttribute('data-bold-swatch') === colour.name));
    });
    /* keep the links pointing at the chosen variant's colour */
    var d = data(card);
    if (d && d.url) {
      card.querySelectorAll('[data-bold-link]').forEach(function (a) {
        a.href = d.url + '?variant=' + ((colour.sizes || []).find(function (s) { return s.a && s.id; }) || {}).id;
      });
    }
    renderSizes(card, colour);
  }

  /* every card picks up its first colour on load — PLP included */
  /* The first colour's swatch state and size run are rendered server-side, so a
     card is usable before this file executes. init() only fills the gap when a
     card arrives with an empty size container — e.g. one injected by a filter
     or an infinite-scroll fetch that skipped the Liquid path. */
  function init(scope) {
    (scope || document).querySelectorAll('[data-bold-card]').forEach(function (card) {
      if (card.dataset.boldReady) return;
      card.dataset.boldReady = '1';
      var sizes = card.querySelector('[data-bold-sizes]');
      /* Bold: the first SHOWN swatch, not colours[0] - the visible subset varies
         per product, so colours[0] may not be on the card at all. */
      if (sizes && sizes.children.length === 0) selectColour(card, card.dataset.boldInitial || null);
    });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-bold-card]');
    if (!card) return;

    var sw = e.target.closest('[data-bold-swatch]');
    if (sw) { e.preventDefault(); selectColour(card, sw.getAttribute('data-bold-swatch')); return; }

    if (e.target.closest('[data-bold-qa-close]')) { e.preventDefault(); closeQA(card); return; }

    var toggle = e.target.closest('[data-bold-qa-toggle]');
    if (toggle) {
      e.preventDefault();
      if (card.classList.contains('is-qa-open')) { closeQA(card); }
      else { closeAll(); openQA(card); }
      return;
    }

    var size = e.target.closest('.bold-card__qa-size[data-variant-id]');
    if (size) { e.preventDefault(); addToCart(size); }
  });

  function openQA(card) {
    card.classList.add('is-qa-open');
    var t = card.querySelector('[data-bold-qa-toggle]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeQA(card) {
    card.classList.remove('is-qa-open');
    var t = card.querySelector('[data-bold-qa-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  /* only one sheet open at a time — two open sheets in a row is confusing
     and the second obscures the first on a narrow screen */
  function closeAll(except) {
    document.querySelectorAll('[data-bold-card].is-qa-open').forEach(function (c) {
      if (c !== except) closeQA(c);
    });
  }

  /* tap anywhere else, or press Escape, to dismiss */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bold-card]')) closeAll();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  function addToCart(btn) {
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var label = btn.textContent;
    btn.textContent = '…';

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      var secs = (drawer.getSectionsToRender() || []).map(function (s) { return s.section; }).filter(Boolean);
      if (secs.length) { body.sections = secs.join(','); body.sections_url = window.location.pathname; }
    }

    fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || res.message);
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);                 /* refreshes AND opens */
        } else if (typeof window.updateCartCounters === 'function') {
          window.updateCartCounters();
        }
        btn.textContent = '✓';
        var c = btn.closest('[data-bold-card]');
        if (c) setTimeout(function () { closeQA(c); }, 400);
      })
      .catch(function () { btn.textContent = '✕'; })
      .then(function () {
        setTimeout(function () { btn.textContent = label; delete btn.dataset.busy; }, 1500);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }

  /* sections re-render in the theme editor and on PLP filtering */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function () {});
  /* Watching the whole document is deliberate - cards arrive from PLP filtering,
     the editor, and app-injected markup - but the callback must stay cheap: it
     fired a full-document querySelectorAll on every mutation on the page,
     including ones from third-party scripts. Now it only reacts when element
     nodes were actually added, and coalesces bursts into one pass per frame.
     init() is itself idempotent per card via data-bold-ready, so a pass that
     finds nothing new costs one query. */
  var pending = false;
  new MutationObserver(function (records) {
    if (pending) return;
    var added = records.some(function (r) {
      return r.addedNodes.length && Array.prototype.some.call(r.addedNodes, function (n) {
        return n.nodeType === 1;
      });
    });
    if (!added) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* "View all" follows the active collection tab. The tab buttons are wired with an
   inline onclick by the vendor section, so listen rather than rebind. */
document.addEventListener('click', function (e) {
  var tab = e.target.closest('[data-bold-tab-url]');
  if (!tab) return;
  var url = tab.getAttribute('data-bold-tab-url');
  if (!url) return;
  var section = tab.closest('.shopify-section') || document;
  var wrap = section.querySelector('[data-bold-viewall]');
  var link = wrap && wrap.querySelector('a');
  if (link) link.setAttribute('href', url);
});
